import { HelpTooltip } from './HelpTooltip';
import type { ToolHelpId } from '../help/toolHelp';
import './Slider.css';

interface Props {
  label: string;
  help?: ToolHelpId;
  value: number;
  min: number;
  max: number;
  step?: number;
  defaultValue?: number;
  onChange: (value: number) => void;
}

// Labelled range slider with a numeric readout, double-click-to-reset, and an
// optional help "?" icon.
export function Slider({
  label,
  help,
  value,
  min,
  max,
  step = 1,
  defaultValue = 0,
  onChange,
}: Props) {
  return (
    <div className="slider">
      <div className="slider__head">
        <span className="slider__label">
          {label}
          {help && <HelpTooltip id={help} />}
        </span>
        <span
          className="slider__value"
          onDoubleClick={() => onChange(defaultValue)}
          title="Double-click to reset"
        >
          {Number.isInteger(step) ? Math.round(value) : value.toFixed(2)}
        </span>
      </div>
      <input
        type="range"
        className="slider__range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        onDoubleClick={() => onChange(defaultValue)}
      />
    </div>
  );
}
